import { AFFILIATE_PROGRAM, REFERRAL_PROGRAM } from '@Web/Pages/Web/Home/constants.jsx';
import SectionHeader from '@Web/Src/Components/SectionHeader';

function ReferralPrograms({ className = '' }) {
    return (
        <div className={`${className} text-dark mt-14 block w-full`}>
            <SectionHeader
                icon='plus'
                title={__('Referral program or affiliate program — we’ve got you covered')}
                desc={
                    <>
                        {__(
                            'Whether you’re looking to ask customers or affiliates to refer, we’ve got a solution for you. We’ve been voted the '
                        )}
                        <a
                            href={
                                'https://referral-factory.com/learn/best-referral-software-tools-to-use-for-customer-referral-programs/'
                            }
                            target={'_blank'}
                            className={'cursor-pointer underline'}
                        >
                            {__('best referral software')}
                        </a>
                        {__(' by reviewers across the globe.')}
                    </>
                }
                className='mx-auto !max-w-[540px]'
            />
            <div className='main-border !border-t-yellow small:block mx-auto mt-10 flex min-h-[400px] w-full max-w-[730px] flex-wrap gap-5 rounded-3xl !border-t-[5px] px-7 py-12'>
                <div className='flex-1'>
                    <h3 className='mb-5 mt-10 text-2xl font-semibold'>
                        {__('Customer referral program')}
                    </h3>
                    {REFERRAL_PROGRAM.map((item) => {
                        return (
                            <div className='mt-4 flex items-start gap-1' key={item.title}>
                                <img src='/assets/images/svg/web/check.svg' alt='abilities' />
                                <p className='font-base leading-5'>
                                    <span className='font-semibold'>{item.title}</span>&nbsp;
                                    {item.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
                <div className='flex-1'>
                    <div className='flex'>
                        <img
                            className='small:mt-5 mx-auto w-[256px]'
                            src='/assets/images/webp/web/customer-referral-program.webp'
                            alt={'referral software customer-referral-program'}
                        />
                    </div>
                </div>
            </div>
            <div className='main-border !border-t-blue small:block mx-auto mt-10 flex min-h-[400px] w-full max-w-[730px] flex-wrap gap-5 rounded-3xl !border-t-[5px] px-7 py-12'>
                <div className='flex-1'>
                    <div className='flex'>
                        <img
                            className='small:mt-b mx-auto w-[256px]'
                            src='/assets/images/webp/web/afiliate-program.webp'
                            alt={'referral software affiliate-program'}
                        />
                    </div>
                </div>
                <div className='flex-1'>
                    <h3 className='mb-5 mt-10 text-2xl font-semibold'>
                        {__('Affiliate program')}
                    </h3>
                    {AFFILIATE_PROGRAM.map((item) => {
                        return (
                            <div className='mt-4 flex items-start gap-1' key={item.title}>
                                <img src='/assets/images/svg/web/check.svg' alt='abilities' />
                                <p className='font-base leading-5'>
                                    <span className='font-semibold'>{item.title}</span>
                                    &nbsp;
                                    {item.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default ReferralPrograms;
